<div>
  <form>
    <div class="global-search-bar">
      <va-icon size="small" name="search" class="search-icon"></va-icon>
      <input
        type="text"
        placeholder="Search for Company, Industry, Comp Table, Analyst, or Broker..."
        matInput
        (click)="toggleOverlay()"
        [formControl]="queryField"
        [(ngModel)]="prevInputSearchQuery"
        cdkOverlayOrigin
        cdkConnectedOverlayPosition="bottom"
        #trigger="cdkOverlayOrigin"
        id="search-input"
        class="va-global-search"
        (keyup.arrowleft)="globalSearchKeyActions('left')"
        (keyup.arrowright)="globalSearchKeyActions('right')"
        (keyup.enter)="globalSearchKeyActions('enter')"
        (keyup.arrowup)="onArrowUp($event, selectedTabIndex)"
        (keyup.arrowdown)="onArrowDown($event, selectedTabIndex)"
        autocomplete="off"
        #searchInput
      />
      <va-icon
        *ngIf="queryField.value?.length > 0"
        size="small"
        name="close"
        class="close-icon"
      ></va-icon>
    </div>

    <ng-template
      cdkConnectedOverlay
      cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
      [cdkConnectedOverlayHasBackdrop]="true"
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOpen"
      cdkConnectedOverlayBackdropClass="backdrop"
      (detach)="onBackdropClick()"
      (overlayOutsideClick)="onBackdropClick()"
      #overlayTemplate="cdkConnectedOverlay"
    >
      <div class="result-dropdown">
        <!-- loader starts -->
        <div *ngIf="isSearchResultLoading" class="loading">
          <div
            *ngFor="
              let dummySection of [
                0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14
              ]
            "
          >
            <nz-skeleton
              [nzTitle]="true"
              [nzActive]="true"
              [nzParagraph]="false"
            ></nz-skeleton>
          </div>
        </div>
        <!-- loader ends -->
        <!-- recently viewed companies starts -->
        <div
          *ngIf="
            splitView &&
            isOpen &&
            recentlyVisitedCompanies.length > 0 &&
            !isSearchResultLoading
          "
          (keyup.enter)="globalSearchKeyActions('enter')"
        >
          <div class="header-container">
            <div class="header-sub-container">
              <span class="header">Recently Viewed Companies</span>
            </div>
          </div>
          <div class="recent-company-list" id="recentList">
            <li
              *ngFor="let row of recentlyVisitedCompanies; let i = index"
              class="list-option"
              [ngClass]="{ active: i === activeIndex }"
            >
              <a
                [routerLink]="getCompanyLink(row.sn)"
                (click)="onSearchResultClicked('ticker', row.sn, row.cid)"
              >
                <div class="company-result">
                  <div nz-col class="company-first-col">
                    <div class="ticker-name">
                      <span
                        nz-tooltip
                        [nzTooltipTitle]="row.sn"
                        nzTooltipPlacement="top"
                      >
                        {{ row.sn || "" }}
                      </span>
                    </div>
                  </div>
                  <div nz-col class="company-middle-col">
                    <div class="comp-name">
                      <span
                        nz-tooltip
                        [nzTooltipTitle]="row.n"
                        nzTooltipPlacement="top"
                      >
                        {{ row.n }}
                      </span>
                    </div>
                  </div>
                  <div nz-col class="company-status-recently">
                    <div class="comp-status">
                      <span
                        *ngIf="row.c === 0"
                        nz-tooltip
                        nzTooltipTitle="No Consensus"
                        nzTooltipPlacement="top"
                      >
                        No Consensus
                      </span>
                    </div>
                    <div class="comp-status" *ngIf="row.c === 1"></div>
                    <div class="comp-status">
                      <span
                        *ngIf="row.c === 2"
                        nz-tooltip
                        nzTooltipTitle="Inactive"
                        nzTooltipPlacement="top"
                      >
                        Inactive
                      </span>
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </div>
        </div>
        <div
          *ngIf="
            queryField.value?.length === 0 &&
            isOpen &&
            recentlyVisitedCompanies.length === 0 &&
            !isSearchResultLoading
          "
        >
          <div class="recent-company-list no-recent-company" id="recentList">
            <div class="header-container">
              <div class="header-sub-container">
                <span class="header">Recently Viewed Companies</span>
              </div>
              <div class="no-results">You haven't viewed any companies yet</div>
            </div>
          </div>
          <div
            class="information-text list-option"
            routerLink="/reporting/allcompany"
          >
            <li class="browse-all-link">
              <a> Browse all companies </a>
            </li>
          </div>
        </div>
        <!-- recently viewed companies ends -->

        <!-- result tabs start -->
        <div *ngIf="!splitView && !isSearchResultLoading && isOpen">
          <div id="search-tab-results">
            <nz-tabset
              [nzSelectedIndex]="selectedTabIndex"
              (nzSelectedIndexChange)="onTabChange($event)"
              (keyup.arrowleft)="globalSearchKeyActions('left')"
              (keyup.arrowright)="globalSearchKeyActions('right')"
              (keyup.enter)="globalSearchKeyActions('enter')"
              (keyup.arrowup)="onArrowUp($event, selectedTabIndex)"
              (keyup.arrowdown)="onArrowDown($event, selectedTabIndex)"
            >
              <nz-tab nzTitle="All">
                <div
                  *ngIf="
                    searchResult &&
                      searchResult['All_Combined'] &&
                      searchResult['All_Combined'].length > 0;
                    else noAllMessage
                  "
                  class="all-result result-container"
                  id="all"
                >
                  <div
                    *ngFor="let row of searchResult['All_Combined']; index as i"
                  >
                    <li
                      *ngIf="row.all_category === 'Company'"
                      class="search-result-option list-option"
                      [ngClass]="{ active: i === activeIndexes[0] }"
                    >
                      <a
                        [routerLink]="getCompanyLink(row.sn)"
                        (click)="
                          onSearchResultClicked('ticker', row.sn, row.cid)
                        "
                      >
                        <div class="company-result">
                          <div nz-col class="company-first-col">
                            <div class="ticker-name">
                              <span
                                nz-tooltip
                                [nzTooltipTitle]="row.sn"
                                nzTooltipPlacement="top"
                                [innerHtml]="
                                  row.sn | textHighlight: matchQueryString
                                "
                              >
                                {{ row.sn || "" }}
                              </span>
                            </div>
                          </div>
                          <div nz-col class="second-Col">
                            <div class="all-comp-name">
                              <span
                                nz-tooltip
                                [nzTooltipTitle]="row.n"
                                nzTooltipPlacement="top"
                                [innerHtml]="
                                  row.n | textHighlight: matchQueryString
                                "
                              >
                                {{ row.n }}
                              </span>
                            </div>
                          </div>
                          <div nz-col class="third-col-type">
                            <span class="all-type">Company</span>
                          </div>
                          <div nz-col class="company-status fourth-col-status">
                            <div class="comp-status" *ngIf="row.c === 0">
                              <span
                                nz-tooltip
                                nzTooltipTitle="No Consensus"
                                nzTooltipPlacement="top"
                              >
                                No Consensus
                              </span>
                            </div>
                            <div class="comp-status" *ngIf="row.c === 1"></div>
                            <div class="comp-status" *ngIf="row.c === 2">
                              <span
                                nz-tooltip
                                nzTooltipTitle="Inactive"
                                nzTooltipPlacement="top"
                              >
                                Inactive
                              </span>
                            </div>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li
                      *ngIf="row.all_category === 'Industry'"
                      class="search-result-option list-option"
                      [value]="{ row, tab: 'ticker' }"
                      [ngClass]="{
                        active: i === activeIndexes[0]
                      }"
                    >
                      <a
                        [routerLink]="['comparative-analysis/current']"
                        [queryParams]="{
                          comp_type: 'industry',
                          id: row.industryid,
                          sub_id: row.subindustryid ? row.subindustryid : -1
                        }"
                        (click)="handleIndustryClick(row)"
                      >
                        <div class="company-result">
                          <div
                            nz-col
                            *ngIf="companyExists"
                            class="company-first-col"
                          ></div>
                          <div
                            nz-col
                            class="second-Col"
                            [ngClass]="{
                              companyPresent: !companyExists
                            }"
                          >
                            <div class="only-industry">
                              <span
                                nz-tooltip
                                [nzTooltipTitle]="row.n"
                                nzTooltipPlacement="top"
                                [innerHtml]="
                                  row.n | textHighlight: matchQueryString
                                "
                              >
                                {{ row.n }}
                              </span>
                            </div>
                          </div>
                          <div nz-col class="third-col-type">
                            <span class="all-type">Industry</span>
                          </div>
                          <div
                            nz-col
                            class="company-status fourth-col-status"
                          ></div>
                        </div>
                      </a>
                    </li>
                    <li
                      *ngIf="row.all_category === 'Industry Comp Tables'"
                      class="search-result-option list-option"
                      [value]="{ row, tab: 'ticker' }"
                      [ngClass]="{
                        active: i === activeIndexes[0]
                      }"
                    >
                      <a
                        [routerLink]="['comparative-analysis/current']"
                        [queryParams]="{ comp_type: 'system', id: row.tab_id }"
                        (click)="
                          onSearchResultClicked('comps', row.n, row.tab_id)
                        "
                      >
                        <div class="company-result">
                          <div
                            nz-col
                            *ngIf="companyExists"
                            class="company-first-col"
                          ></div>
                          <div
                            nz-col
                            class="second-Col"
                            [ngClass]="{
                              companyPresent: !companyExists
                            }"
                          >
                            <div class="result-item">
                              <span
                                nz-tooltip
                                [nzTooltipTitle]="row.n"
                                nzTooltipPlacement="top"
                                [innerHtml]="
                                  row.n | textHighlight: matchQueryString
                                "
                              >
                                {{ row.n }}
                              </span>
                            </div>
                          </div>
                          <div nz-col class="third-col-type">
                            <span class="all-type">Comp Table</span>
                          </div>
                          <div
                            nz-col
                            class="company-status fourth-col-status"
                          ></div>
                        </div>
                      </a>
                    </li>
                    <li
                      *ngIf="row.all_category === 'Analyst'"
                      class="search-result-option list-option"
                      [value]="{ row, tab: 'ticker' }"
                      [ngClass]="{
                        active: i === activeIndexes[0]
                      }"
                    >
                      <a
                        routerLink="reporting/analyst/{{ row.id }}"
                        (click)="
                          onSearchResultClicked('analyst', row.n, row.id)
                        "
                      >
                        <div class="company-result">
                          <div
                            nz-col
                            *ngIf="companyExists"
                            class="company-first-col"
                          ></div>
                          <div
                            nz-col
                            class="second-Col"
                            [ngClass]="{
                              companyPresent: !companyExists
                            }"
                          >
                            <div class="result-item">
                              <span
                                nz-tooltip
                                [nzTooltipTitle]="row.n"
                                nzTooltipPlacement="top"
                                [innerHtml]="
                                  row.n | textHighlight: matchQueryString
                                "
                              >
                                {{ row.n || "" }}
                              </span>
                              <span>&nbsp;</span>
                              <span
                                nz-tooltip
                                [nzTooltipTitle]="row.brokersn"
                                nzTooltipPlacement="top"
                              >
                                (<span
                                  [innerHtml]="
                                    row.brokersn
                                      | textHighlight: matchQueryString
                                  "
                                ></span
                                >)
                              </span>
                            </div>
                          </div>
                          <div nz-col class="third-col-type">
                            <span class="all-type">Analysts</span>
                          </div>
                          <div
                            nz-col
                            class="company-status fourth-col-status"
                          ></div>
                        </div>
                      </a>
                    </li>
                    <li
                      *ngIf="row.all_category === 'Broker'"
                      class="search-result-option list-option"
                      [value]="{ row, tab: 'ticker' }"
                      [ngClass]="{
                        active: i === activeIndexes[0]
                      }"
                    >
                      <a
                        routerLink="{{ getBrokerLink(row.sn) }}"
                        (click)="onSearchResultClicked('broker', row.n, row.sn)"
                      >
                        <div class="company-result">
                          <div
                            nz-col
                            *ngIf="companyExists"
                            class="company-first-col"
                          ></div>
                          <div
                            nz-col
                            class="second-Col"
                            [ngClass]="{
                              companyPresent: !companyExists
                            }"
                          >
                            <div class="result-item">
                              <span
                                nz-tooltip
                                [nzTooltipTitle]="row.n"
                                nzTooltipPlacement="top"
                                [innerHtml]="
                                  row.n | textHighlight: matchQueryString
                                "
                              >
                                {{ row.n }}
                              </span>
                            </div>
                          </div>
                          <div nz-col class="third-col-type">
                            <span class="all-type">Broker</span>
                          </div>
                          <div
                            nz-col
                            class="fourth-col-status"
                            class="company-status"
                          ></div>
                        </div>
                      </a>
                    </li>
                  </div>
                </div>
                <div class="information-text">
                  <li class="all-tab-info">
                    <span> Navigate tabs to see full results </span>
                  </li>
                </div>
                <ng-template #noAllMessage>
                  <div class="no-results result-container">No results</div>
                </ng-template>
              </nz-tab>
              <nz-tab nzTitle="Companies">
                <div
                  *ngIf="
                    searchResult &&
                      searchResult['Company'] &&
                      searchResult['Company'].data &&
                      searchResult['Company'].count > 0;
                    else noCompanyMessage
                  "
                  id="company"
                  class="result-container"
                >
                  <li
                    *ngFor="let row of searchResult['Company'].data; index as i"
                    class="search-result-option list-option"
                    [value]="{ row, tab: 'ticker' }"
                    [ngClass]="{ active: i === activeIndexes[1] }"
                  >
                    <a
                      [routerLink]="getCompanyLink(row.sn)"
                      (click)="onSearchResultClicked('ticker', row.sn, row.cid)"
                    >
                      <div class="company-result">
                        <div nz-col class="company-first-col">
                          <div class="ticker-name">
                            <span
                              nz-tooltip
                              [nzTooltipTitle]="row.sn"
                              nzTooltipPlacement="top"
                              [innerHtml]="
                                row.sn | textHighlight: matchQueryString
                              "
                            >
                              {{ row.sn || "" }}
                            </span>
                          </div>
                        </div>
                        <div nz-col class="company-middle-col">
                          <div class="comp-name">
                            <span
                              nz-tooltip
                              [nzTooltipTitle]="row.n"
                              nzTooltipPlacement="top"
                              [innerHtml]="
                                row.n | textHighlight: matchQueryString
                              "
                            >
                              {{ row.n }}
                            </span>
                          </div>
                        </div>
                        <div nz-col class="company-status">
                          <div class="comp-status" *ngIf="row.c === 0">
                            <span
                              nz-tooltip
                              nzTooltipTitle="No Consensus"
                              nzTooltipPlacement="top"
                            >
                              No Consensus
                            </span>
                          </div>
                          <div class="comp-status" *ngIf="row.c === 1"></div>
                          <div class="comp-status" *ngIf="row.c === 2">
                            <span
                              nz-tooltip
                              nzTooltipTitle="Inactive "
                              nzTooltipPlacement="top"
                            >
                              Inactive
                            </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </li>
                </div>
                <div
                  class="information-text list-option"
                  routerLink="/reporting/allcompany/1/{{ queryField.value }}"
                >
                  <li
                    class="browse-all-link"
                    *ngIf="
                      searchResult &&
                      searchResult['Company'] &&
                      searchResult['Company'].data &&
                      searchResult['Company'].count > 30
                    "
                  >
                    <a>
                      See all results in companies &nbsp;
                      {{ searchResult.length }}
                    </a>
                  </li>
                  <li
                    class="browse-all-link list-option"
                    *ngIf="
                      searchResult &&
                      searchResult['Company'] &&
                      searchResult['Company'].data &&
                      searchResult['Company'].count <= 30
                    "
                  >
                    <a routerLink="/reporting/allcompany">
                      Browse all companies &nbsp;
                      {{ searchResult.length }}
                    </a>
                  </li>
                  <li
                    class="browse-all-link list-option"
                    *ngIf="searchResult && !searchResult['Company']"
                  >
                    <a routerLink="/reporting/allcompany">
                      Browse all companies &nbsp;
                      {{ searchResult.length }}
                    </a>
                  </li>
                </div>
                <ng-template #noCompanyMessage>
                  <div class="no-results result-container">No results</div>
                </ng-template>
              </nz-tab>
              <nz-tab nzTitle="Industries">
                <div class="industry-section">
                  <div
                    nz-col
                    *ngIf="
                      searchResult &&
                        searchResult['Industry'] &&
                        searchResult['Industry'].data &&
                        searchResult['Industry'].count > 0;
                      else noIndustryMessage
                    "
                    id="industry"
                    class="result-container"
                  >
                    <li
                      [ngClass]="{ active: i === activeIndexes[2] }"
                      *ngFor="
                        let row of searchResult['Industry'].data;
                        index as i
                      "
                      id="global_search_{{ i }}"
                      [value]="{ row, tab: 'industry' }"
                      class="search-result-option list-option"
                    >
                      <a
                        [routerLink]="['comparative-analysis/current']"
                        [queryParams]="{
                          comp_type: 'industry',
                          id: row.industryid,
                          sub_id: row.subindustryid ? row.subindustryid : -1
                        }"
                        (click)="handleIndustryClick(row)"
                      >
                        <div class="company-result non-anchor-gs-item">
                          <div class="result-item">
                            <span
                              nz-tooltip
                              [nzTooltipTitle]="row.n"
                              nzTooltipPlacement="top"
                              [innerHtml]="
                                row.n | textHighlight: matchQueryString
                              "
                            >
                              {{ row.n }}
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                  </div>
                  <div class="information-text list-option">
                    <li class="browse-all-link">
                      <a routerLink="sectors_industries">
                        Browse all industries &nbsp;
                      </a>
                    </li>
                  </div>

                  <ng-template #noIndustryMessage>
                    <div class="no-results result-container">No results</div>
                  </ng-template>
                </div>
              </nz-tab>
              <nz-tab nzTitle="Comp Tables" id="search-comp-tab-results">
                <div
                  class="result-container"
                  *ngIf="
                    searchResult &&
                      searchResult['Industry Comp Tables'] &&
                      searchResult['Industry Comp Tables'].data &&
                      searchResult['Industry Comp Tables'].count > 0;
                    else noCompTableMessage
                  "
                  id="industryComp"
                >
                  <li
                    class="search-result-option list-option"
                    [ngClass]="{ active: i === activeIndexes[3] }"
                    *ngFor="
                      let row of searchResult['Industry Comp Tables'].data;
                      index as i
                    "
                    id="global_search_{{ i }}"
                    [value]="{ row, tab: 'comps' }"
                  >
                    <a
                      [routerLink]="['comparative-analysis/current']"
                      [queryParams]="{ comp_type: 'system', id: row.tab_id }"
                      (click)="
                        onSearchResultClicked('comps', row.n, row.tab_id)
                      "
                    >
                      <div class="company-result">
                        <div class="result-item">
                          <span
                            nz-tooltip
                            [nzTooltipTitle]="row.n"
                            nzTooltipPlacement="top"
                            [innerHtml]="
                              row.n | textHighlight: matchQueryString
                            "
                          >
                            {{ row.n }}
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                </div>
                <div
                  class="information-text list-option"
                  routerLink="comptables/user"
                >
                  <li class="browse-all-link" *ngIf="!isModelsOnlyUser">
                    <a> Browse all comp tables &nbsp; </a>
                  </li>
                </div>
                <ng-template #noCompTableMessage>
                  <div class="no-results result-container">No results</div>
                </ng-template>
              </nz-tab>
              <nz-tab nzTitle="Analysts">
                <div
                  class="result-container"
                  *ngIf="
                    searchResult &&
                      searchResult['Analyst'] &&
                      searchResult['Analyst'].data &&
                      searchResult['Analyst'].count > 0;
                    else noAnalystMessage
                  "
                  id="analyst"
                >
                  <li
                    [ngClass]="{ active: i === activeIndexes[4] }"
                    class="search-result-option list-option"
                    *ngFor="let row of searchResult['Analyst'].data; index as i"
                    id="global_search_{{ i }}"
                    [value]="{ row, tab: 'analyst' }"
                  >
                    <a
                      routerLink="reporting/analyst/{{ row.id }}"
                      (click)="onSearchResultClicked('analyst', row.n, row.id)"
                    >
                      <div class="company-result">
                        <div nz-col nzSpan="6">
                          <div class="result-item">
                            <span
                              nz-tooltip
                              [nzTooltipTitle]="row.brokersn"
                              nzTooltipPlacement="top"
                              [innerHtml]="
                                row.brokersn | textHighlight: matchQueryString
                              "
                            >
                              {{ row.brokersn || "" }}
                            </span>
                          </div>
                        </div>
                        <div nz-col nzSpan="6">
                          <div class="result-item">
                            <span
                              nz-tooltip
                              [nzTooltipTitle]="row.n"
                              nzTooltipPlacement="top"
                              [innerHtml]="
                                row.n | textHighlight: matchQueryString
                              "
                            >
                              {{ row.n || "" }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </li>
                </div>
                <div class="information-text"></div>
                <ng-template #noAnalystMessage>
                  <div class="no-results result-container">No results</div>
                </ng-template>
              </nz-tab>
              <nz-tab nzTitle="Brokers">
                <div
                  class="result-container"
                  *ngIf="
                    searchResult &&
                      searchResult['Broker'] &&
                      searchResult['Broker'].data &&
                      searchResult['Broker'].count > 0;
                    else noBrokerMessage
                  "
                  id="brokers"
                >
                  <li
                    class="search-result-option list-option"
                    [ngClass]="{ active: i === activeIndexes[5] }"
                    *ngFor="let row of searchResult['Broker'].data; index as i"
                    id="global_search_{{ i }}"
                    [value]="{ row, tab: 'broker' }"
                  >
                    <a
                      routerLink="{{ getBrokerLink(row.sn) }}"
                      (click)="onSearchResultClicked('broker', row.n, row.sn)"
                    >
                      <div class="company-result">
                        <div class="result-item">
                          <span
                            nz-tooltip
                            [nzTooltipTitle]="row.n"
                            nzTooltipPlacement="top"
                            [innerHtml]="
                              row.n | textHighlight: matchQueryString
                            "
                          >
                            {{ row.n }}
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                </div>
                <div
                  class="information-text list-option"
                  routerLink="reporting/allbrokers"
                >
                  <li class="browse-all-link" *ngIf="!isSellSide">
                    <a> Browse all brokers &nbsp; </a>
                  </li>
                </div>
                <ng-template #noBrokerMessage>
                  <div class="no-results result-container">No results</div>
                </ng-template>
              </nz-tab>
            </nz-tabset>
          </div>
        </div>
        <!-- result tabs ends -->
      </div>
    </ng-template>
  </form>
</div>
